import {guid ,getQueryString} from '../util/util'
import startModel from './taskStartModel'
import $ from 'webpack-zepto'
/**
 * @class Task
 * @export Task
 * @author lei.you
 * @desc 任务对象
 *
 */
class Task{
  /**
   * @constructor
   * @param {object} {
   *  id: ID
   *  gid: ID
   *  pathName: 页面对应的路径
   *  params:
   *  pageParams: 页面参数
   *  keepAlive：缓存
   *  vue: 对应的vue组件
   *  model：启动模式
   * }
   * */
  constructor(params={}){
    if(params.params){
      this.gid=params.params.url_gid;
    }
    this.pathName;
    this.name;
    this.params;
    this.pageParams;
    this.keepAlive;
    this.vue;
    this.model;
    $.extend(this,params);
    this.id=guid.getGuid();
  }
  /**
   * @desc : task 回退方法
   * */
  back(){
    if(this.vue){
      console.log(this.vue);
      this.vue.backToLastPage();
    }else{
      throw ("task vue is undefined......");
    }
  }

 /**
   * @desc : native 注册以后可通过onResume去触发, 每次当activity 切换的时候调用该方法
   * @param : data 数据
   *
   * */
  appear(data){
    if(this.vue){
      this.vue.$options.appear.bind(this.vue)(data)
    }else{
      throw ("current task vue is undefined......");
    }
  }

  /*triggerVueComAppear*
   * @description native 通知h5 网络状态
   * @param status  状态分为 蜂窝移动 wifi 和无网络
   * */
  networkChange(status){
    if(this.vue){
      this.vue.$options.networkChange.bind(this.vue)(status);
    }else{
      throw ("current task vue is undefined......");
    }
  }
  static model=0;

}
export default Task;
